import Swiper from 'swiper/bundle';

export default function blockColumnSlider() {
    document.querySelectorAll('.block-column-slider').forEach(function (block) {
        const slider = block.querySelector('.column-slider');
        if(!slider) return;
        const swiper = new Swiper(slider, {
            speed: 1000,
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            slidesPerView: 2,
            spaceBetween: 24,
            navigation: {
                nextEl: block.querySelector('.column-slider__arrow--next'),
                prevEl: block.querySelector('.column-slider__arrow--prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                992: {
                    slidesPerView: 2,
                },
            }

        });
    });
}
